// @flow
import * as React from 'react';

import DocumentsUploadNew from '@screens/Profile/ProfileDocuments/DocumentsUploadNew/index';
import {
  CompletedIcon, MiniWhatsapp, Miniphone
} from '@images/svg/index';
import { StyledWhatsappButtonNew } from '@styles/buttons';
import { withTranslation } from '@i18n';
import compose from 'lodash/fp/compose';
import { connect } from 'react-redux';
import type { GlobalState } from '@globalTypes';
import type { PropsNewPatient } from './types/index';

import {
  StyledThanksWrapper,
  StyledThanksTitle,
  StyledThanksSubtitle,
  StyledPhoneIcon,
  StyledCompletedWrapper,
  StyledDragDropBottomSection,
  StyledContactIconWrapper,
  StyledWhatsappIcon,
  StyledDragDropBottomHeadline
} from './styles/newPatientUpload';

const NewPatientUploadComponent = ({
  slide,
  setSuccess,
  success,
  formName,
  onTimeSelect,
  isActive,
  t,
  created_patient_id,
  treatmentFormName,
  isModal,
  modalState
}: PropsNewPatient) => {
  const [modalSuccess, setModalSuccess] = React.useState(false);
  React.useEffect(() => {
    setModalSuccess(false);
  }, [modalState]);

  if (!isActive) {
    return null;
  }

  return (
    <StyledThanksWrapper treatmentFormName={treatmentFormName} isModal={isModal}>
      {!treatmentFormName && (
        <StyledThanksTitle treatmentFormName={treatmentFormName} isModal={isModal}>
          {t('ThanksTitle')}
        </StyledThanksTitle>
      )}
      {(success || modalSuccess) && (
        <StyledCompletedWrapper isModal={isModal}>
          <CompletedIcon />
        </StyledCompletedWrapper>
      )}
      <StyledThanksSubtitle
        slide={slide}
        isModal={isModal}
        finderForm={formName === 'FinderForm'}
        treatmentFormName={treatmentFormName}
      >
        {!success && !modalSuccess ? t('ThanksSubtitle') : t('Successfully completed')}
      </StyledThanksSubtitle>

      {!success && !modalSuccess && (
        <DocumentsUploadNew
          isModal={isModal}
          treatmentFormName={treatmentFormName}
          created_patient_id={created_patient_id}
          onTimeSelect={onTimeSelect}
          setSuccess={setSuccess}
          setModalSuccess={setModalSuccess}
        />
      )}

      <StyledDragDropBottomSection treatmentFormName={treatmentFormName}>
        <StyledDragDropBottomHeadline treatmentFormName={treatmentFormName}>
          {t('ContactNow')}
        </StyledDragDropBottomHeadline>
        <StyledContactIconWrapper isModal={isModal}>
          <StyledWhatsappButtonNew
            full
            id="WhatsappContactID"
            href="https://api.whatsapp.com/send?phone=919599818171&text=Hello%20Yapita%20Health.%20I%20need%20medical%20assistance%20for:"
            target="_blank"
            finderForm={formName === 'FinderForm'}
            isModal={isModal}
          >
            {treatmentFormName ? <MiniWhatsapp /> : <StyledWhatsappIcon />}
          </StyledWhatsappButtonNew>
          <StyledWhatsappButtonNew
            full
            id="PhoneID"
            href="tel:+918056005099"
            target="_blank"
            finderForm={formName === 'FinderForm'}
            isModal={isModal}
          >
            {treatmentFormName ? <Miniphone /> : <StyledPhoneIcon />}
          </StyledWhatsappButtonNew>
        </StyledContactIconWrapper>
      </StyledDragDropBottomSection>
    </StyledThanksWrapper>
  );
};

const mapStateToProps = ({ candidateCreate: { created_patient_id } }: GlobalState) => ({
  created_patient_id
});

const NewPatientUpload = compose(
  connect(mapStateToProps),
  withTranslation(['ContactPage'])
)(NewPatientUploadComponent);

export default NewPatientUpload;
